let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9IgsX")).then(() => parcelRequire('AHo5e'));